import { ERROR_TYPES } from 'common/utils/error-codes/error-codes';
import { arrayOf, oneOf, shape, string } from 'prop-types';

export const errorType = shape({
  error: oneOf(Object.values(ERROR_TYPES)).isRequired,
  text: string.isRequired,
});

export const errorListType = arrayOf(
  shape({
    code: string.isRequired,
    message: string.isRequired,
  })
);
